import React, { useState } from 'react';
import CafeReservationDetails from '../../reserves/modals/deprecated/cafeReservationDetails';

const ReserveCafeModal = ({ record }) => {
  const [open, setOpen] = useState(false);

  const openModal = (e) => {
    e.preventDefault();
    setOpen(true);
  }

  return (
    <div>
      <a href="" onClick={openModal}>{record.reserveCafeName} </a>
      <CafeReservationDetails
        isOpen={open}
        reservationId={record.reserveId}
        closeModal={() => setOpen(false)}
      />
    </div>
  );
}


export default ReserveCafeModal;